import { Patient } from "@/redux/slice/auth/types/Patient";

export const getPatientDetails = (patientDetails: Patient) => {
  const patientAge = new Date().getFullYear() - new Date(patientDetails && patientDetails.dateOfBirth).getFullYear();

  return {
    patientName: (patientDetails && `${patientDetails.firstName} ${patientDetails.lastName}`) || "",
    patientUhid: patientDetails?.uhid || "",
    patientGender: patientDetails?.gender || "",
    patientAge: (patientDetails && patientAge) || "",
    patientId: patientDetails?.id || "",
    mobileNumber: patientDetails?.mobileNumber || "",
    emailId: patientDetails?.emailAddress || "",
    patientRelation: patientDetails?.relation || "",
  };
};

export default getPatientDetails;
